(() => {
  angular
    .module('gm.common.services')
    .factory('gmBusinessProfile', gmBusinessProfileService);

  function gmBusinessProfileService(
    btgUser,
    gmApi,
    GmyUtils
  ) {
    'ngInject';

    const INDUSTRIAL_TYPES = [
      {
        id: 'i1',
        name: 'Clothing, Shoes & Accessories'
      },
      {
        id: 'i2',
        name: 'Entertainment & Media'
      },
      {
        id: 'i3',
        name: 'Electronics & Telecommunications'
      },
      {
        id: 'i4',
        name: 'Financial Services'
      },
      {
        id: 'i5',
        name: 'Home, Furniture & Garden'
      },
      {
        id: 'i6',
        name: 'Food Retail & Beverages'
      },
      {
        id: 'i7',
        name: 'Computers, Accessories & Services'
      },
      {
        id: 'i8',
        name: 'Pets & Animals'
      },
      {
        id: 'i9',
        name: 'Subscriptions & Memberships'
      },
      {
        id: 'i10',
        name: 'Health & Personal Care'
      },
      {
        id: 'i11',
        name: 'Arts & Collectables'
      },
      {
        id: 'i12',
        name: 'Stationery, Books & Magazines'
      },
      {
        id: 'i13',
        name: 'Travel'
      },
      {
        id: 'i14',
        name: 'Automobile, Accessories & Parts'
      },
      {
        id: 'i15',
        name: 'Miscellaneous'
      },
      {
        id: 'i16',
        name: 'Non profit'
      },
      {
        id: 'i17',
        name: 'Other'
      }
    ];

    const BUSINESS_TYPES = [{
      id: 'individual',
      name: 'Individual'
    }, {
      id: 'corporation',
      name: 'Registered Corporation'
    }, {
      id: 'llc',
      name: 'Limited Liability Company '
    }, {
      id: 'nonprofit',
      name: 'Nonprofit Organization'

    }, {
      id: 'foreigncorp',
      name: 'Foreign Corporation'
    }, {
      id: 'partnership',
      name: 'Partnership'
    }];

    const USER_BUSINESS_PROFILE_EMPTY = {
      businessName: '',
      industry: '',
      type: '',
      estimatedMonthlyRevenue: 0,
      website: '',
      ratingLink: '',
      corporate: {
        address: {
          street: '',
          streetLine2: '',
          city: '',
          stateOrProvince: '',
          zipOrPostalCode: '',
          countryCode: ''
        },
        taxId: '',
        phone: '',
        email: '',
        servicePhone: '',
        serviceEmail: ''
      }
    };

    function generateProfile(profileDiff) {
      const fullProfile = angular.copy(btgUser.getProfile().businessProfile
        || USER_BUSINESS_PROFILE_EMPTY);

      GmyUtils.mergeObjects(fullProfile, profileDiff);
      return fullProfile;
    }

    return {
      BUSINESS_TYPES,
      INDUSTRIAL_TYPES,
      signUp,
      updateBusinessProfile,
      updateBusinessProfileLocally,
    };

    function signUp(email, password, captcha) {
      return btgUser.signUp(email, password, 'business', captcha);
    }

    function updateBusinessProfile(profileDiff) {
      const fullProfile = generateProfile(profileDiff);

      return gmApi.post('users/profile/business', {
        businessProfile: fullProfile
      }, {
        auth: true
      })
        .then(() => btgUser.updateProfileLocally({
          businessProfile: fullProfile
        }));
    }

    function updateBusinessProfileLocally(profileDiff) {
      const fullProfile = generateProfile(profileDiff);
      btgUser.updateProfileLocally({
        businessProfile: fullProfile
      });
    }
  }
})();
